import React from 'react';
import AIReminders from '../components/AIReminders';

const AIRemindersPage: React.FC = () => {
  return <AIReminders />;
};

export default AIRemindersPage;
